import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: (k) => k,
});

/**
 * The site is served in English only. This provider exists to keep
 * the existing t() call sites working and to enforce lang="en" on the
 * document root.
 */
export function LanguageProvider({ children }) {
  const [lang] = useState("en");

  useEffect(() => {
    document.documentElement.setAttribute("lang", "en");
  }, []);

  const setLang = () => {};

  const t = (key, fallback) => {
    const dict = translations.en || {};
    if (dict[key] !== undefined) return dict[key];
    return fallback ?? key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
